// extracted by mini-css-extract-plugin
module.exports = {"n1iblk5d":"n1iblk5d","seohewe":"seohewe"};